<template>
    <div class="dashboard-container">
        <h2>Dashboard</h2>
        <el-row :gutter="20">
            <el-col :span="24">
                <el-card>
                    <div slot="header">
                        <span>Bienvenido al Dashboard</span>
                    </div>
                    <div>
                        Contenido del Dashboard
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    name: 'BotDashboard',
    data() {
        return {
            token: this.$route.query.token
        }
    }
}
</script>

<style lang="scss" scoped>
.dashboard-container {
    padding: 20px;
}
</style> 